import { defineMessages } from 'react-intl';

export default defineMessages({
    summaryRentedTDCVehicles: {
        id: 'ml.quoteandbind.pa.PolicySummaryRented.Vehicles',
        defaultMessage: 'Rented Trailer / Camper'
    },
    summaryRentedTDCVehicleYear: {
        id: 'ml.quoteandbind.pa.PolicySummaryRented.vehicle.YEAR',
        defaultMessage: 'YEAR'
    },
    summaryRentedTDCVehicleMake: {
        id: 'ml.quoteandbind.pa.PolicySummaryRented.vehicle.MAKE',
        defaultMessage: 'MAKE'
    },
    summaryRentedTDCVehicleModel: {
        id: 'ml.quoteandbind.pa.PolicySummaryRented.vehicle.MODEL',
        defaultMessage: 'MODEL'
    },
    summaryRentedTDCVehicleSerialNo: {
        id: 'ml.quoteandbind.pa.PolicySummaryRented.vehicle.SERIAL NUMBER',
        defaultMessage: 'SERIAL NUMBER'
    }
});
